import Vue from 'vue'
import VueRouter from 'vue-router'

import { isLoggedIn } from '@/vue-apollo'

import Login from '@/components/Login.vue'
import Player from '@/components/Player.vue'
import PlayerQueue from '@/components/PlayerQueue.vue'
import Artist from '@/components/Artist.vue'
import Album from '@/components/Album.vue'
import Genre from '@/components/Genre.vue'
import Search from '@/components/Search.vue'

import Home from '@/views/Home.vue'
import Albums from '@/views/Albums'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    name: 'player',
    component: Player,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'home',
        name: 'home',
        alias: '/',
        component: Home
      },
      {
        path: 'artists/:id',
        name: 'artist',
        component: Artist
      },
      {
        path: 'albums',
        name: 'albums',
        component: Albums
      },
      {
        path: 'albums/recently-added',
        name: 'recently-added-albums',
        component: Albums,
        props: {
          title: 'Recently added albums',
          orderBy: 'INSERTED_AT_DESC'
        }
      },
      {
        path: 'albums/recently-played',
        name: 'recently-played-albums',
        component: Albums,
        props: {
          title: 'Recently played albums',
          played: true,
          orderBy: 'PLAYED_AT_DESC'
        }
      },
      {
        path: 'albums/most-played',
        name: 'most-played-albums',
        component: Albums,
        props: {
          title: 'Your most played albums',
          played: true,
          orderBy: 'PLAY_COUNT_DESC'
        }
      },
      {
        path: 'albums/:id',
        name: 'album',
        component: Album
      },
      {
        path: 'genres/:id',
        name: 'genre',
        component: Genre
      },
      {
        path: 'queue',
        name: 'queue',
        component: PlayerQueue
      },
      {
        path: 'search',
        name: 'search',
        component: Search
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLoggedIn()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
